import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {IIconConfig} from '../../../../shared-modules/shared-icons/models';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';

@Component({
    selector: 'app-shared-modal-header',
    templateUrl: './shared-modal-header.component.html',
    styleUrls: ['./shared-modal-header.component.scss'],
    standalone: false
})
export class SharedModalHeaderComponent {

  @Output() readonly emitClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() callbackBeforeEventEmit: () => void;
  @Input() callbackAfterEventEmit: () => void;
  @Input() isCloseIconVisible = true;
  @Input() applyTitle: string;

  get getTitle(): string {
    return this.applyTitle;
  }

  get getCloseIcon(): IIconConfig {
    return {
      icon: IconsEnum.close,
      tooltip: 'Close',
      border: false,
      colour: IconColourEnum.white
    };
  }

  onCloseModal(): void {
    if (this.callbackBeforeEventEmit) {
      this.callbackBeforeEventEmit();
    }
    this.emitClose.emit(true);
    if (this.callbackAfterEventEmit) {
      this.callbackAfterEventEmit();
    }
  }


}
